import React from "react";
import "./Home.scss"
import { Part } from "../../containers/Part/Part";
import logo from "../../resources/svg/logo-big.svg";
import logoText from "../../resources/svg/logo-text.svg";
import { ScrollVideo } from "../../components/ScrollVideo/ScrollVideo";
import { ParallaxWrapper } from "../../components/ParallaxWrapper/ParallaxWrapper";
import { ContactForm } from "../../components/Forms/ContactForm/ContactForm";

interface IProps {

}

export function Home(props: IProps) {
    return (
        <div className="home-wrapper">
            <Part className={"splash"}>
                <div className="left-side">
                    <img src={logo} alt="Logo"/>
                </div>
                <div className="right-side">
                    <img src={logoText} alt="Logo txt"/>
                </div>
            </Part>
            <Part>
                <div className="left-side with-vignette">
                    <ParallaxWrapper>
                        <ScrollVideo loop={true} src="/video/IMG_2173_small.mov" behaviour="play" />
                    </ParallaxWrapper>
                </div>
                <div className="right-side content-container">
                    <div className="part-content">
                        <h1>Welkom bij <b>MALO Timmerwerken</b></h1>
                        <p><em>Uw Specialist in Timmerwerk en Renovatie</em></p>
                        <p>Sinds 2009 biedt MALO Timmerwerken vakmanschap en maatwerk op het gebied van timmerwerk, renovatie, en nieuwbouw. Met passie voor ons vak en oog voor detail zorgen we ervoor dat elk project voldoet aan de hoogste kwaliteitsstandaarden. Of het nu gaat om de renovatie van een monumentale woning, het plaatsen van een dakkapel, of een op maat gemaakte kast, wij realiseren uw visie met zorg en precisie.</p>
                        <p>Bent u op zoek naar een bouwbedrijf dat niet alleen hoogwaardige kwaliteit levert, maar ook met u meedenkt in elk detail? Bij Malo Timmerwerken combineren we jarenlange ervaring met vakmanschap en passie voor bouwen. Of het nu gaat om nieuwbouw, renovatie, of maatwerk projecten, wij brengen uw visie tot leven – op tijd en binnen budget.</p>
                    </div>
                </div>
            </Part>
            <Part variant={'reversed'} headerBackground={'primary'}>
                <div className="left-side content-container">
                    <div className="part-content">
                        <h1>Professioneel <b>vakmanschap</b></h1>
                        <p>Met ruim 15 jaar ervaring, passie voor ons vak en een focus op persoonlijke service, staat Malo Timmerwerken garant voor kwaliteit en vakmanschap. Wij luisteren naar uw wensen, denken met u mee en werken met aandacht voor detail. Of u nu kiest voor een kleine aanpassing of een grootschalig renovatieproject, we begeleiden u met zorg en professionaliteit.</p>
                        <p>Wij begrijpen dat bouwen een grote investering is. Daarom zetten we ons in voor heldere communicatie, strakke projectplanning en een transparante aanpak. Ons team bestaat uit ervaren specialisten die trots zijn op hun werk en elk project aanpakken alsof het hun eigen woning is. </p>
                    </div>
                </div>
                <div className="right-side">
                    <ParallaxWrapper distance={100}>
                        <img src="https://as1.ftcdn.net/v2/jpg/02/19/42/54/1000_F_219425449_Xb8tudxcRwebk9Os9Rfz4p1F0WHCHB6e.jpg" alt="renovatie" />
                    </ParallaxWrapper>
                </div>
            </Part>
            <Part>
                <div className="left-side">
                    <ParallaxWrapper>
                        <img src="https://as2.ftcdn.net/v2/jpg/00/99/93/47/1000_F_99934797_jnUHzNokYDLygFNEa5oP35t5Y3IegrMG.jpg" alt="blokschaaf" />
                    </ParallaxWrapper>
                </div>
                <div className="right-side content-container">
                    <div className="part-content">
                        <h1><b>Ervaar</b> het verschil</h1>
                        <p>Dus waarom zou u voor minder gaan? Ervaar het verschil van een bouwpartner die begrijpt wat u belangrijk vindt: kwaliteit, betrouwbaarheid en een resultaat dat indruk maakt. Laten we samen bouwen aan uw droomproject!</p>
                        <p>Neem vandaag nog contact met ons op voor een vrijblijvend gesprek en ontdek wat wij voor uw woning kunnen betekenen!</p>
                    </div>
                </div>
            </Part>
            <Part variant={'dark'} headerBackground={'secondary'}>
                <div className="left-side content-container" id="contact-wrapper">
                    <div className="part-content">
                        <h1>Neem contact op</h1>
                        <div style={{overflow: 'hidden', maxWidth: 'calc(100vw - 50px)'}}>
                            <ContactForm />
                        </div>
                    </div>
                </div>
                <div className="right-side" />
            </Part>
        </div>
    )
}
